import Iframe from '@components/common/Iframe';

import styles from './styles.module.css';

interface InternetProps {
  pageUrl: string;
}

const Internet = ({ pageUrl }: InternetProps) => {
  return (
    <div className={styles.internet_iframe_container}>
      <Iframe pageUrl={pageUrl} />
    </div>
  );
};

export default Internet;
